<template>
  <div class="success-container">
    <div class="success-logo">
      <img class="successImg" src="~@/assets/success.png" />
    </div>
    <div class="success-info">
      <div class="success-info-title">购买成功</div>
      <div class="success-info-tip">
        *将为您分配业务员，具体请在订单详情中查看
      </div>
    </div>
    <div class="buttonWrapper">
      <div class="button" @click="goIndex">返回首页</div>
      <div class="button button-primary" @click="goOrderList">查看订单</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "buySuccess",
  methods: {
    goIndex() {
      this.$router.replace({ path: "/home" });
    },

    goOrderList() {
      // this.$router.replace({ path: "/orderList" });
    }
  }
};
</script>

<style scoped lang="less">
.success {
  &-container {
    background: #fff;
    height: 100%;
  }
  &-logo {
    text-align: center;
    .successImg {
      margin-top: 120px;
      width: 120px;
      height: 120px;
      display: inline-block;
    }
  }
  &-info {
    text-align: center;
    margin-top: 80px;
    &-title {
      font-size: 21px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(17, 17, 17, 1);
    }
    &-tip {
      margin-top: 20px;
      font-size: 13px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(145, 145, 145, 1);
    }
  }
}

.buttonWrapper {
  margin-top: 130px;
  text-align: center;
}

.button {
  width: 300px;
  height: 80px;
  line-height: 80px;
  font-size: 15px;
  color: #379dfd;
  border: 1px solid rgba(55, 157, 253, 1);
  border-radius: 4px;
  & + & {
    margin-left: 20px;
  }
  &-primary {
    background: rgba(3, 157, 248, 1);
    color: #fff;
  }
}
</style>
